import React, { type ReactNode } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import styled from "styled-components";

export interface IContentDetailsProps {
  dismissPath: string;
  children?: ReactNode;
}

export const ContentDetails = ({
  dismissPath,
  children,
}: IContentDetailsProps) => (
  <>
    <ContentDetailsLayer to={dismissPath} />
    <ContentDetailsContainer>
      <ContentDetailsCloseLink className="close" to={dismissPath} />

      <Container fluid className="pt-3 px-5">
        {children}
      </Container>
    </ContentDetailsContainer>
  </>
);

const ContentDetailsLayer = styled(Link)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const ContentDetailsContainer = styled.div`
  position: fixed;
  right: 0;
  top: 56px;
  bottom: 0;
  width: 390px;
  background: white;
  box-shadow: -10px 0 10px 1px rgba(150, 150, 150, 0.2);
  overflow: scroll;
  z-index: 1;

  dt {
    color: #a0a5c3;
  }

  .content-details-branding {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .content-details-branding .content-details-branding-logo {
    margin-right: 1rem;
  }

  .content-details-branding .content-details-branding-details > * {
    margin: 0;
    line-height: 100%;
  }
`;

const ContentDetailsCloseLink = styled(Link)`
  position: absolute;
  top: 10px;
  right: 30px;
  background: #465582;
  opacity: 1;
  width: 30px;
  height: 30px;
  padding: 0;
  color: white;
  border-radius: 100%;

  &:hover {
    color: white;
    text-decoration: none;
  }
  &:before {
    content: "×";
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    height: 100%;
  }
`;

/**
 * @deprecated
 */
export default ContentDetails;
